import React, { useEffect, useState } from 'react';

const PageLoadTest: React.FC = () => {
  const [loadTime, setLoadTime] = useState<number>(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const startTime = performance.now();
    
    console.log('🔄 PageLoadTest: Компонент монтируется');
    
    // Симулируем загрузку данных
    const loadData = async () => {
      try {
        // Проверяем доступность API
        const response = await fetch('/api/health?v=' + Date.now(), { 
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        
        console.log('🔍 PageLoadTest: Получен ответ от API:', response.status, response.statusText);
        
        // 401 означает, что сервер работает, но требует аутентификации
        if (response.status === 401) {
          const endTime = performance.now();
          setLoadTime(endTime - startTime);
          setIsLoaded(true);
          console.log('✅ PageLoadTest: API сервер работает (требует аутентификации)');
          return;
        }
        
        // 200 означает, что сервер работает и аутентификация прошла успешно
        if (response.status === 200) {
          const endTime = performance.now();
          setLoadTime(endTime - startTime);
          setIsLoaded(true);
          console.log('✅ PageLoadTest: API сервер работает (аутентификация успешна)');
          return;
        }
        
        if (!response.ok) {
          console.log('❌ PageLoadTest: API вернул ошибку:', response.status, response.statusText);
          throw new Error(`API недоступен: ${response.status}`);
        }
        
        const endTime = performance.now();
        setLoadTime(endTime - startTime);
        setIsLoaded(true);
        
        console.log('✅ PageLoadTest: Данные загружены за', endTime - startTime, 'мс');
      } catch (err) {
        const endTime = performance.now();
        setLoadTime(endTime - startTime);
        setError(err instanceof Error ? err.message : 'Неизвестная ошибка');
        
        console.error('❌ PageLoadTest: Ошибка загрузки:', err);
      }
    };

    loadData();

    return () => {
      console.log('🔄 PageLoadTest: Компонент размонтируется');
    };
  }, []);

  return (
    <div style={{ 
      padding: '20px', 
      fontFamily: 'monospace', 
      backgroundColor: '#f5f5f5',
      borderRadius: '8px',
      margin: '20px'
    }}>
      <h3>🔍 Тест загрузки страницы</h3>
      
      <div style={{ marginBottom: '10px' }}>
        <strong>Время загрузки:</strong> {loadTime.toFixed(2)} мс
      </div>
      
      <div style={{ marginBottom: '10px' }}>
        <strong>Статус:</strong> 
        {isLoaded ? '✅ API сервер работает' : error ? '❌ Ошибка' : '⏳ Загрузка...'}
      </div>
      
      {error && (
        <div style={{ 
          marginBottom: '10px', 
          color: 'red',
          backgroundColor: '#ffe6e6',
          padding: '10px',
          borderRadius: '4px'
        }}>
          <strong>Ошибка:</strong> {error}
        </div>
      )}
      
      <div style={{ marginBottom: '10px' }}>
        <strong>URL:</strong> {window.location.href}
      </div>
      
      <div style={{ marginBottom: '10px' }}>
        <strong>User Agent:</strong> {navigator.userAgent}
      </div>
      
      <div style={{ marginBottom: '10px' }}>
        <strong>Время:</strong> {new Date().toLocaleString()}
      </div>
      
      <button 
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        🔄 Обновить страницу
      </button>
    </div>
  );
};

export default PageLoadTest;
